import React from "react";

export const ErrorInsufficientFundsStep = () => (
  <>
    <div className="authorise-bank-transfer-header">
      <h4 className="authorise-bank-transfer-title red">Error</h4>
    </div>
    <div className="authorise-bank-transfer-body-content">
      <div className="authorise-bank-transfer-description black text-center">
        <p>
          {Drupal.t("There are not enough funds in the available balance to make this payment. Please add funds and try again later.")}
        </p>
      </div>
    </div>
  </>
);
